import { TYPE_COLORS } from "../constants";

export default function TypeBadge({ type }) {
  const c = TYPE_COLORS[type] || { bg: "#eee", text: "#333" };
  return (
    <span style={{
      background: c.bg, color: c.text,
      fontSize: "0.68rem", fontWeight: 500,
      letterSpacing: "0.1em", textTransform: "uppercase",
      padding: "2px 8px", borderRadius: "2px", flexShrink: 0,
    }}>
      {type}
    </span>
  );
}
